// Make openQuickShop available globally
window.openQuickShop = function(productId) {
  console.log('Opening quick shop for product:', productId);
  
  // Find the actual modal opener for this product
  const modalOpener = document.getElementById(`ModalOpener-${productId}`);
  
  if (modalOpener) {
    // Find the button inside the modal opener
    const modalButton = modalOpener.querySelector('button');
    
    if (modalButton) {
      // Create a MouseEvent to simulate a click
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      
      modalButton.dispatchEvent(clickEvent);
    } else {
      // Fallback to the product page
      const productUrl = modalOpener.getAttribute('data-product-url') || 
                        `/products/${productId}`;
      window.location.href = productUrl;
    }
  } else {
    // Final fallback - go to the product page
    window.location.href = `/products/${productId}`;
  }
};

// Also hide the quick-add-modal__toggle by default
document.addEventListener('DOMContentLoaded', function() {
  const style = document.createElement('style');
  style.textContent = `
    .quick-add-modal__toggle {
      display: none !important;
    }
    
    .quick-add-modal[open] .quick-add-modal__toggle {
      display: flex !important;
      position: fixed;
      top: 1.5rem;
      right: 1.5rem;
      z-index: 105;
    }
  `;
  document.head.appendChild(style);
});